import Enums from "./Enums.js";

const CodeCompDisabledConfig = {
  GCP: [Enums.COMPONENT.MINI_LEFT_DRAWER_BENEFITS]
};

export default CodeCompDisabledConfig;
